/** All backend async checkers for `task` module */
export enum TaskCheckersKeysEnum {
  /** Check that BRS task priority(ies) exists by identifier(s) */
  TASK_PRIORITY_ASSERT_EXISTS_BY_ID = 'task/task-priority-assert-exists-by-id',
  /** Check that BRS task priority(ies) exists by DTO(s) */
  TASK_PRIORITY_ASSERT_EXISTS_BY_DTO = 'task/task-priority-assert-exists-by-dto',
  /** Check that BRS task status(es) exists by identifier(s) */
  TASK_STATUS_ASSERT_EXISTS_BY_ID = 'task/task-status-assert-exists-by-id',
  /** Check that BRS task status(es) exists by DTO(s) */
  TASK_STATUS_ASSERT_EXISTS_BY_DTO = 'task/task-status-assert-exists-by-dto',
  /** Check that Value Added Tax (VAT, rus. "ИНН") rate(s) exists by identifier(s) */
  NDS_ASSERT_EXISTS_BY_ID = 'task/nds-assert-exists-by-id',
  /** Check that Value Added Tax (VAT, rus. "ИНН") rate(s) exists by DTO(s) */
  NDS_ASSERT_EXISTS_BY_DTO = 'task/nds-assert-exists-by-dto',
}
